import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { ClientConfirmModeEnum, ClientReginstering, CuttingClient } from 'cloud-shared-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class RegisterService {
  constructor(private http: HttpClient) {}

  register(userId: number, client: CuttingClient): Promise<number> {
    let searchParams: HttpParams = new HttpParams();
    searchParams = searchParams.append('userId', userId.toString());

    return new Promise((resolve, reject) => {
      this.http
        .post(ApiLinks.client, client, { params: searchParams, responseType: 'text' })
        .subscribe((response: string) => {
          resolve(+response);
        }, reject);
    });
  }

  activateClientByKey(keyActivate: string): Observable<boolean> {
    let searchParams: HttpParams = new HttpParams();
    searchParams = searchParams.append('key', keyActivate);

    return this.http
      .get(ApiLinks.activateClient, { params: searchParams })
      .pipe(map((response: { res: boolean }) => response.res));
  }

  getRegisteredOptions(userId: number): Promise<ClientReginstering> {
    let searchParams: HttpParams = new HttpParams();
    searchParams = searchParams.append('userId', userId.toString());

    return new Promise((resolve, reject) => {
      this.http
        .get<ClientReginstering>(ApiLinks.clientRegisteredOptions, { params: searchParams })
        .subscribe(response => {
          resolve(response);
        }, reject);
    });
  }

  getUsePhoneNumber(userId: number): Promise<boolean> {
    let searchParams: HttpParams = new HttpParams();
    searchParams = searchParams.append('userId', userId.toString());

    return new Promise((resolve, reject) => {
      this.http.get<boolean>(ApiLinks.usePhoneNumber, { params: searchParams }).subscribe(response => {
        resolve(response);
      }, reject);
    });
  }

  getConfirmMode(userId: number): Promise<ClientConfirmModeEnum> {
    let searchParams: HttpParams = new HttpParams();
    searchParams = searchParams.append('userId', userId.toString());

    return new Promise((resolve, reject) => {
      this.http.get<number>(ApiLinks.clientConfirmMode, { params: searchParams }).subscribe(response => {
        resolve(response);
      }, reject);
    });
  }

  getAdminCountryCode(userId: number): Observable<string> {
    let searchParams: HttpParams = new HttpParams();
    searchParams = searchParams.append('userId', userId.toString());

    return this.http.get<string>(ApiLinks.adminCountryCode, { params: searchParams });
  }
}
